<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="dedication">for Brigid</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 4dedication.vue?a3d75774